import React from "react";
import { AggregateContainer } from "../../../containers";
const Aggregate = (props) => {
  return <AggregateContainer {...props} />;
};

export default Aggregate;
